import config from 'company-management/config'

const authApi = `${config.apiHost}/oem-auth`
const customerApi = `${config.apiHost}/oem-customer`

export default {
    companies: {
        url: `${authApi}/admin/companies`,
        type: 'GET',
    },
    agentInfo: {
        url: `${authApi}/admin/companies/{id}/agent`,
        type: 'GET',
    },
    updateAgentInfo: {
        url: `${authApi}/admin/companies/{id}/agent`,
        type: 'PUT',
    },
    weWorkSetting: {
        url: `${customerApi}/public/settings`,
        type: 'GET',
    },
    updateWeWorkSetting: {
        url: `${customerApi}/public/settings`,
        type: 'POST',
    },
    updateCreator: {
        url: `${authApi}/admin/companies/{id}/creator`,
        type: 'PUT',
    },
    menuTree: {
        url: `${authApi}/admin/modules/tree`,
        type: 'GET',
    },
    updateCompany: {
        url: `${authApi}/admin/companies/{id}`,
        type: 'PUT',
    },
    addCompany: {
        url: `${authApi}/admin/companies/add`,
        type: 'POST',
    },
}
